module.exports = __webpack_public_path__ + "static/media/vector-down.fd38d69d.svg";